import LaneFeesFormOverview from 'app/Apps/Pricing/LaneFees/LaneFeesFormOverview'
import LaneFeesFormUpdate from 'app/Apps/Pricing/LaneFees/LaneFeesFormUpdate'
import LaneFeesChangeHistory from 'app/Apps/Pricing/LaneFees/LaneFeesChangeHistory'
import LaneFeesCreateStepper from 'app/Apps/Pricing/LaneFees/LaneFeesCreateStepper'
import LaneFeesBulkCreate from 'app/Apps/Pricing/LaneFees/LaneFeesBulkCreate'

import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useHasPermission from 'app/hooks/useHasPermission'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'

import tableConfig from './LaneFees.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.BulkCreate,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

export default function LaneFees() {
    const canCreate = useHasPermission(['contract_basis_create'])
    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: CommonRoutes.Overview,
                Component: LaneFeesFormOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Data Update',
                url: CommonRoutes.DataUpdate,
                Component: LaneFeesFormUpdate,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Change History',
                url: CommonRoutes.ChangeHistory,
                Component: LaneFeesChangeHistory,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: canCreate ? LaneFeesCreateStepper : undefined,
                BulkCreate: canCreate ? LaneFeesBulkCreate : undefined,
            }}
            sidebarTabs={tabs}
            name={tableConfig.name}
            defaultTab={CommonRoutes.Overview}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName="LaneFees"
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>
    )
}
